import { useGetConfig, useGetProfile } from 'hooks/startupHooks';

import { ProfileIconMenu as ProfileIconMenuWSC } from '@trackman/web-shared-components';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

type Props = {
  setDisplayContent: React.Dispatch<React.SetStateAction<boolean>>;
};

const ProfileIconMenu = ({ setDisplayContent }: Props) => {
  const { name, surname, organizationName } = useStores().me;
  const { data: profile } = useGetProfile();
  const { data: config } = useGetConfig();
  const { t } = useTranslation();

  if (!profile || !config) return null;

  return (
    <ProfileIconMenuWSC
      label={t('Profile')}
      name={name}
      surname={surname}
      profilePhotoUrl={profile.profilePhotoUrl}
      accountUrl={config.myAccountUrl}
      supportUrl='https://trackman.zendesk.com/hc/en-us'
      logoutUrl={config.logoutUrl ? config.logoutUrl + '?returnUrl=' + window.origin : undefined}
      userOrganization={organizationName}
      onMenuItemClick={(menuItemUrl) => {
        setDisplayContent(false);
        window.location.href = menuItemUrl;
      }}
      accountLabel={t('Account')}
      supportLabel={t('Support and FAQ')}
      logoutLabel={t('Log out')}
    />
  );
};

export default ProfileIconMenu;
